// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgBed = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 2.75a.75.75 0 1 0-1.5 0v4.5a.75.75 0 0 0 1.5 0V4.5h11v2.75a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-1.5 0V3h-11v-.25Zm-.998 7.761H3.5V15.5h13v-4.988l-.002-.001c-.307-.11-.768-.258-1.367-.408-1.2-.3-2.95-.603-5.131-.603-2.18 0-3.932.303-5.13.603-.6.15-1.06.298-1.368.408ZM3.5 17.25V17h13v.25a.75.75 0 0 0 1.5 0V10a.75.75 0 0 0-.44-.683l-.31.683.31-.683h-.002l-.003-.002-.01-.004-.03-.014a10.029 10.029 0 0 0-.513-.199c-.35-.124-.857-.288-1.508-.45C14.194 8.321 12.32 8 10 8c-2.32 0-4.193.322-5.494.647-.651.163-1.159.327-1.508.451a9.99 9.99 0 0 0-.513.2l-.03.013-.01.004-.003.001H2.44v.001L2.75 10l-.31-.683A.75.75 0 0 0 2 10v7.25a.75.75 0 0 0 1.5 0Z"
    />
  </svg>
)

export default SvgBed
